import 'es6-promise'
import { Observable, Subject } from 'rxjs'
import { PlaceInAkixiNameSpace } from '../../utils/Utils'

// Subject for closing the menu.
const optionsMenuClosed: Subject<void> = new Subject<void>()

// Observable for when to close the menu.
export const optionsMenuClosed$: Observable<void> = optionsMenuClosed.asObservable()

// Announce when the menu should be closed.
export const announceOptionsMenuClose = (): void => optionsMenuClosed.next()

PlaceInAkixiNameSpace('AnnounceOptionsMenuClose', announceOptionsMenuClose)
